import { normalizeConnectBrokerSlug } from "@/views/Dashboard/Profile/connectBroker/connectBrokerWizardConstants"

/** Served from `public/broker-logos/` (no spaces — CRA dev server 500s on spaced paths). */
const BROKER_LOGOS_PUBLIC_DIR = "/broker-logos"

/** Filenames under `public/broker-logos/`. */
const BROKER_WIZARD_LOGO_FILES: Record<string, string> = {
  binance: "binance-broker-logo.png",
  ibkr: "interactivebrokers-broker-logo.png",
  interactivebrokers: "interactivebrokers-broker-logo.png",
  liquidbrokers: "liquidbrokers-broker-logo.png",
  liquid: "liquidbrokers-broker-logo.png",
  ctrader: "ctrader-broker-logo.png",
  tradingview: "tradingview-broker-logo.png",
  tradingview_paper: "tradingview-broker-logo.png",
  hyperliquid: "hyperliquid-broker-logo.png",
  mt5: "metatrader5-broker-logo.png",
  metatrader5: "metatrader5-broker-logo.png",
  mt4: "metatrader4-broker-logo.png",
  metatrader4: "metatrader4-broker-logo.png",
  ninjatrader: "ninjatrader-broker-logo.png",
  oanda: "oanda-broker-logo.png",
  tradovate: "Tradovate-broker-logo.png",
}

/** Dark-mode wordmarks (white text). Falls back to light file when missing. */
const BROKER_WIZARD_LOGO_DARK_FILES: Record<string, string> = {
  ibkr: "interactivebrokers-broker-logo-dark-mode.png",
  interactivebrokers: "interactivebrokers-broker-logo-dark-mode.png",
  liquidbrokers: "liquidbrokers-broker-logo-dark-mode.png",
  liquid: "liquidbrokers-broker-logo-dark-mode.png",
  ctrader: "ctrader-broker-logo-dark-mode.png",
  tradingview: "tradingview-broker-logo-dark-mode.png",
  tradingview_paper: "tradingview-broker-logo-dark-mode.png",
  hyperliquid: "hyperliquid-broker-logo-dark-mode.png",
  mt5: "metatrader5-broker-logo-dark-mode.png",
  metatrader5: "metatrader5-broker-logo-dark-mode.png",
  mt4: "metatrader4-broker-logo-dark-mode.png",
  metatrader4: "metatrader4-broker-logo-dark-mode.png",
  oanda: "oanda-broker-logo-dark-mode.png",
  tradovate: "tradovate-broker-logo-dark-mode.png",
}

export type ResolveConnectBrokerLogoOptions = {
  /** When true, prefer `*-dark-mode.png` variants when available. */
  dark?: boolean
}

export function resolveConnectBrokerLogoUrl(
  brokerName: string,
  options?: ResolveConnectBrokerLogoOptions
): string | null {
  const slug = normalizeConnectBrokerSlug(brokerName)
  const file = options?.dark
    ? BROKER_WIZARD_LOGO_DARK_FILES[slug] ?? BROKER_WIZARD_LOGO_FILES[slug]
    : BROKER_WIZARD_LOGO_FILES[slug]
  if (!file) return null
  const base = process.env.PUBLIC_URL || ""
  return `${base}${BROKER_LOGOS_PUBLIC_DIR}/${file}`
}
